import AdminConstants from 'constants/AdminConstants';

export const getBearerGrantTypeAuthHeaders = () => {
  const token = localStorage.getItem(AdminConstants.token_key);

  return `Bearer ${token}`;
};

export const getRequestHeaders = () => {
  return {
    'Content-Type': 'application/json',
    Authorization: getBearerGrantTypeAuthHeaders(),
  };
};
